











































import { MeterMapping } from './MeterMapping';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import VatsAPI from '@/Shared/VatsAPI';
import MeterRow from './MeterRow.vue';

export default mixins(LocationBasedMixin).extend({
    components: {
        MeterRow
    },
    data() {
        return {
            loading: false,
            mappings: [] as MeterMapping[],
            newMapping: null as MeterMapping | null
        };
    },
    async beforeMount() {
        await this.reloadData();
    },
    methods: {
        async reloadData() {
            this.loading = true;
            this.newMapping = null;
            try {
                const mappings = await VatsAPI.get<MeterMapping[]>(`${this.location}/Meters/Mappings`);
                this.mappings = mappings.data;
            }
            finally {
                this.loading = false;
            }
        },
        deleted(map: MeterMapping) {
            const index = this.mappings.findIndex(item => item === map);
            this.mappings.splice(index, 1);
        },
        cancelNew() {
            this.newMapping = null;
        },
        add() {
            this.newMapping = {} as MeterMapping;
        },
        added(newMap: MeterMapping) {
            this.newMapping = null;
            this.mappings.splice(0, 0, newMap);
        },
        updated(map: MeterMapping) {
            const index = this.mappings.findIndex(item => item.recID === map.recID);
            this.mappings.splice(index, 1, map);
        },
        async locationChanged() {
            this.reloadData();
        }
    },
});
